module.exports = __webpack_public_path__ + "img/云闪住.5162317a.jpg";